import ProfilePicture from "@/components/common/profile-picture";
import Link from "next/link";
import clsx from "clsx";

type FounderCardProps = {
	member: {
		name: string;
		jobTitle: string | null;
		image?: string | null;
		username?: string;
		isFounder?: boolean;
		isVerified?: boolean;
	};
};

const FounderCard = ({ member }: FounderCardProps) => {
	const profileLink = member.username ? `/user/${member.username}` : "#";
	const isLinkActive = Boolean(member.username);

	return (
		<Link
			href={profileLink}
			aria-disabled={!isLinkActive}
			className={clsx(
				"flex items-center gap-3 rounded border px-4 py-2 transition-all duration-200",
				"hover:border-gray-300 hover:bg-muted/50",
				!isLinkActive && "pointer-events-none opacity-60"
			)}
		>
			<ProfilePicture
				isFounder={member.isFounder}
				isVerified={member.isVerified}
				profilePictureUrl={member.image || ""}
				className={{
					container: "h-12 w-12 rounded-full p-0.5",
					image: "rounded-full object-cover text-gray-600",
					badgeImage: "-bottom-3 h-5 w-5 md:h-7 md:w-7",
				}}
			/>

			<div className="flex flex-col justify-center">
				<span className="text-sm font-semibold text-foreground">{member.name || "Name"}</span>
				<span className="text-xs text-muted-foreground">{member.jobTitle?.trim() || "Role"}</span>
			</div>
		</Link>
	);
};

export default FounderCard;
